import { StampTheme } from '../../types';

export const STAMP_DEFAULT_THEME: StampTheme = {
    paddingX: 10,
    paddingY: 10,
    radius: 10,
    shadow: 'xs',
    typographyVariant: 'hero.s',
    fontWeight: 'default',
    lineHeight: 0.9,
    colors: {
        primary: {
            background: 'primary.base',
            text: 'common.white',
        },
        secondary: {
            background: 'secondary.base',
            text: 'common.white',
        },
        tertiary: {
            background: 'accent.base',
            text: 'common.black',
        },
    },
    fixedColors: {
        neutral: {
            background: 'neutral.lightest',
            text: 'common.black',
        },
        black: {
            background: 'common.black',
            text: 'common.white',
        },
        white: {
            background: 'common.white',
            text: 'common.black',
        },
    },
};
